<h2>Add {{ complexField.name }}</h2>
<div class="main-complex-form-container">
  <ng-scrollbar [autoHeightDisabled]="false" [autoWidthDisabled]="false">
    <div fxFlex="auto">
      <div class="form-content">
        <attributes-editor
          [dataSource]="attributesEditorDataSource"
          fxFlexWidth="100%"
        >
        </attributes-editor>
      </div>
    </div>
  </ng-scrollbar>
</div>
<mat-dialog-actions>
  <div>
    <button
      mat-flat-button
      color="primary"
      [disabled]="isInvalid()"
      (click)="onSave()"
    >
      {{ getButtonName() }}
    </button>
    <button type="button" mat-button (click)="dialogRef.close()">Cancel</button>
  </div>
</mat-dialog-actions>
